import { Minus, Plus } from "lucide-react";

export default function Counter({ value = 0, onChange, testId, label }) {
  const v = Number(value) || 0;
  return (
    <div className="flex items-center gap-2" data-testid={testId}>
      {label && <span className="text-lg font-semibold min-w-[64px]">{label}</span>}
      <button type="button" aria-label={`Fewer ${label || ""}`} data-testid={`${testId}-minus`} onClick={() => onChange(Math.max(0, v - 1))}
        className="w-12 h-12 rounded-full border-2 border-[#E6DBCF] bg-white flex items-center justify-center hover:border-[#8C3415] active:scale-95 disabled:opacity-40" disabled={v === 0}>
        <Minus className="w-5 h-5" />
      </button>
      <span data-testid={`${testId}-value`} className="w-10 text-center font-heading text-2xl font-bold">{v}</span>
      <button type="button" aria-label={`More ${label || ""}`} data-testid={`${testId}-plus`} onClick={() => onChange(v + 1)}
        className="w-12 h-12 rounded-full bg-[#2B5338] text-white flex items-center justify-center hover:bg-[#1E3D28] active:scale-95">
        <Plus className="w-5 h-5" />
      </button>
    </div>
  );
}
